<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.2305 3.16888L12.2305 19.1689" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.46121 7.08325L12.2302 2.29367L17 7.08325" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.46121 15.2104L12.2302 20L17 15.2104" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
